import Vue from 'vue'
import Router from 'vue-router'
import InspiringProjects from './views/InspiringProjects.vue'
import StyleSpecialists from './views/StyleSpecialists.vue'
import ScrapBookDemo from './views/ScrapBook.vue'
import ScrapBookVue from './views/ScrapbookDemo.vue'
import NewTalent from './views/NewTalent.vue'
import HomePage from './views/HomePage.vue'
import OnTheMove from './views/OnTheMove.vue'
import LaunchEmail from './views/LaunchEmail.vue'
import LaunchEmailArtists from './views/LaunchEmailArtists.vue'
import EmailSignatures from './views/EmailSignatures.vue'
import NewsletterTemplate from './views/NewsletterTemplate.vue'
import ShowcaseIllus from './views/ShowcaseIllus.vue'
import KidsBooks from './views/KidsBooksTemplate.vue'
import ShowcaseAnim from './views/ShowcaseAnim.vue'
import authAdmin from './auth-admin.js'
import RecommendEmail from './views/RecommendEmail.vue'
import ScrapBookAnim from './views/ScrapBookAnim.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/newtal',
      component: NewsletterTemplate,
      children: [
        {
          path: '/inspiring-projects/:id',
          name: 'inspiring projects',
          component: InspiringProjects,
          props: true
        },
        {
          path: '/style-specialists/:id',
          name: 'style specialists',
          component: StyleSpecialists,
          props: true
        },
        {
          path: '/scrapbook/:id',
          name: 'scrapbook',
          component: ScrapBookDemo,
          props: true,
          meta: {
            ga: true
          }
        },
        {
          path: '/interview-with-an-animator/:id',
          name: 'scrapbook -anim',
          component: ScrapBookAnim,
          props: true,
          meta: {
            ga: true
          }
        },
        {
          path: '/scrapbook-demo/:id',
          name: 'scrapbook-demo',
          component: ScrapBookVue,
          props: true
        },
        {
          path: '/new-talent-profile/:id',
          name: 'new talent profile',
          component: NewTalent,
          props: true
        },
        {
          path: '/on-the-move/:id',
          name: 'on the move',
          component: OnTheMove,
          props: true
        },
        {
          path: '/launch-email',
          name: 'launch email',
          component: LaunchEmail
        },
        {
          path: '/launch-email-artists',
          name: 'launch email artists',
          component: LaunchEmailArtists
        },
        {
          path: '/showcase/:id',
          name: 'showcase illustration',
          component: ShowcaseIllus,
          props: true
        },
        {
          path: '/kidsbooks/:id',
          name: 'kidsbooks illustration',
          component: KidsBooks,
          props: true
        },
        {
          path: '/showcase-anim/:id',
          name: 'showcase animation',
          component: ShowcaseAnim,
          props: true
        }
      ]
    },
    {
      path: '/recommend/:dept/:guid',
      name: 'recommend',
      component: RecommendEmail,
      props: true
    },
    {
      path: '/recommend/:dept/:guid/:irating',
      name: 'recommend',
      component: RecommendEmail,
      props: true
    },
    {
      path: '/email-signatures',
      name: 'email signatures',
      component: EmailSignatures,
      beforeEnter: async function (to, from, next) {
        let si = await authAdmin.isSignedIn()
        if(!si){
          window.location = '/login'
        }
        else {
          next()
        }
      }
    },
    {
      path: '/',
      name: 'default page',
      component: HomePage
    }
  ]
})

async function tagPage(path){
  const mpath = '/newtalent' + path
  if(window.location.hostname === process.env.VUE_APP_LIVE_HOST)
  {
    if(window.gtag) {
      window.gtag('config', process.env.VUE_APP_GTAG_ID, {'page_path': mpath })
    }
  }
}

router.beforeEach((to, from, next) => {
  if(from.path !== to.path) {
    if(to.meta.ga) {
      tagPage(to.path)
    }
  }
  next()
})

export default router
